import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";

const apiKey = import.meta.env.VITE_POSTHOG_API_KEY;

if (apiKey && !navigator.webdriver) {
    posthog.init(apiKey, {
        api_host: import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com",
        capture_pageview: false,
        capture_pageleave: true,
    });
    posthog.register({ environment: import.meta.env.VITE_APP_ENV });
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
    if (!apiKey) return <>{children}</>;
    return <PHProvider client={posthog}>{children}</PHProvider>;
}
